import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PathwaysBackendMockService } from './pathways-backend.service.mock.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [PathwaysBackendMockService],
  exports: []
})
export class PathwaysBackendMockModule {
  constructor(private service: PathwaysBackendMockService) { }

  static forRoot(): ModuleWithProviders<PathwaysBackendMockModule> {
    return {
      ngModule: PathwaysBackendMockModule,
      providers: [PathwaysBackendMockService]
    };
  }
}
